// extracted by css-extract-rspack-plugin
export default {"modelCollapseSection":"ylKEh","itemBackground":"vv5mZ","selected":"TAR1V","emptyState":"LQeSQ"};